"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
const WarningsComponent_vue_1 = __importDefault(require("./WarningsComponent.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'select-option',
    props: {
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    components: {
        AppButton: AppButton_vue_1.default,
        WarningsComponent: WarningsComponent_vue_1.default,
    },
    methods: {
        saveData() {
            this.onsave({ type: 'option' });
        },
    },
});
